import React, { useEffect, useState } from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Grid,
  IconButton,
} from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import useStyles from '../CommoditiyDetailsDialog/styles';
import DividerWithText from '../DividerWithText/DividerWithText';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import VerticalTabsForMenuItems from './VerticalTabsForMenuItems';
import { VIEW_MODE_STATES } from '../EquipmentHoldingProfile/utils';
import {
  getMenuItemsHoldingProfiles,
  getMenuItemTranslation,
} from '../../redux/actions/menuItemsActions';
import MenuItemsTranslationsModal from '../MenuItemsTranslations/MenuItemsTranslationsModal';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from '../../utils/utils';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      minWidth: 600,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    minHeight: 200,
    minWidth: 600,
  },
}))(MuiDialogContent);

interface PGDIProps {
  open: boolean;
  setOpen: Function;
  readOnly?: boolean;
}

export default function CustomizedDialogs({
  setOpen,
  open,
  readOnly = false,
}: PGDIProps) {
  const {
    item: {
      menuItem: { id, itemName, itemStatus, product, groupId, dayPart },
      commodities,
      excluded,
      availability,
      categoryId,
    },
  } = useSelector((state: RootStateOrAny) => state.PlatformsReducer);
  const dispatch: any = useDispatch();
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const style = useStyles();
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const objSearch = { brand: selectedBrand, limit: 100 };
    if (id) {
      dispatch(getMenuItemsHoldingProfiles(objSearch, categoryId, groupId, id));
    }
  }, [categoryId, groupId, id]);
  const refreshOnSave = () => {
    const objSearch = { brand: selectedBrand, limit: 100 };
    dispatch(getMenuItemsHoldingProfiles(objSearch, categoryId, groupId, id));
  };
  const [viewMode, setViewMode] = useState(VIEW_MODE_STATES.READ);
  const handleAddProfile = () => {
    setViewMode(VIEW_MODE_STATES.CREATE);
  };
  const excludedShow = !excluded
    ? false
    : Object.keys(excluded).some(key => excluded[key].length); ////Translations modal
  const { menuItemTranslations } = useSelector((state: RootStateOrAny) => state.MenuItemsReducer);
  ////Menu items Translations modal.
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  useEffect(() => {
    if (thisUser.hasCreateTranslationsMultilanguage) {
      getMenuItemTranslation(+id, selectedBrand)(dispatch);
    }
  }, [id, thisUser]);
  const [MenuItemsSelected, setMenuItemsSelectedSelected] = useState(null);
  const [OpenMenuItemsTranslations, setOpenMenuItemsTranslations] =
    useState(false);
  const handleCloseTranslationModal = () => {
    setOpenMenuItemsTranslations(false);
  };
  //////////////////////////

  const { t } = useTranslation();

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth={'md'}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {itemName}
        </DialogTitle>
        <MuiDialogContent dividers>
          <Grid container>
            <Grid item xs={12}>
              <Typography>
                {t('productGroups.viewDetail.GeneralInformation')}
              </Typography>
            </Grid>
            {dayPart && (
              <Grid item xs={3}>
                <Typography variant="caption" gutterBottom>
                  {t('operationHours.daypart')}:{' '}
                  {t(
                    `operationHours.daypart.${textToSnakeCase(
                      dayPart?.soldAsDayPartCategory,
                    )}`,
                    dayPart?.soldAsDayPartCategory,
                  )}
                </Typography>
              </Grid>
            )}
            <Grid item xs={3}>
              <Typography variant="caption" gutterBottom>
                {t('productGroups.viewDetail.freshCheck')}:{' '}
                {t(`productGroups.viewDetail.freshCheck.no`, 'No')}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" gutterBottom>
                {t('productGroups.viewDetail.shelfLife')}: 8hrs
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" gutterBottom>
                {t('app.common.status')}:{' '}
                {t(`app.common.${textToSnakeCase(itemStatus)}`, itemStatus)}
              </Typography>
            </Grid>
          </Grid>
        </MuiDialogContent>
        <DialogContent>
          <Grid container>
            <Grid item xs={8}>
              <Grid>
                <Grid item xs={12}>
                  <Typography gutterBottom>
                    {t('productGroups.viewDetail.includedCommodities')}
                  </Typography>
                </Grid>

                {commodities?.map(e => (
                  <Grid item xs={12} key={e.ingredientId}>
                    <Typography
                      gutterBottom
                      variant="caption"
                      style={{ textTransform: 'none' }}
                    >
                      {e.ingredient.toLowerCase()}
                    </Typography>
                    <Typography variant="caption">
                      {` - ${e.quantity} - ${e.units}`}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid container>
                <Grid item xs={12}>
                  <div className={style.translationsContainer}>
                    <div className={style.containerAppBar}>
                      <Typography className={style.containerTitle}>
                        {t('app.common.translations')} (
                        {
                          menuItemTranslations?.filter(e => e.value !== null)
                            .length
                        }
                        )
                      </Typography>
                      <MenuItemsTranslationsModal
                        OpenMenuItemsTranslations={OpenMenuItemsTranslations}
                        handleClose={handleCloseTranslationModal}
                        MenuItemsSelected={MenuItemsSelected}
                      />
                    </div>
                    <div>
                      {menuItemTranslations?.map(translation =>
                        translation.value === null ? (
                          ''
                        ) : (
                          <div key={translation.language.id}>
                            <DividerWithText mt={10}>
                              {t(translation.language.name?.toString())}
                            </DividerWithText>
                            <Typography className={style.translationItem}>
                              {translation.value}
                            </Typography>{' '}
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} style={{ marginTop: 10 }}>
                  {t('productGroups.viewDetail.available')}
                </Grid>
                <Grid item xs={12}>
                  {availability?.map(e => (
                    <Typography variant="caption" key={e.id}>
                      {e.region}/{t(`app.common.countries.${textToSnakeCase(e.country)}`, e.country)}
                    </Typography>
                  ))}
                </Grid>
              </Grid>
              {excludedShow && (
                <Grid container>
                  <Grid item xs={12} style={{ marginTop: 10 }}>
                    {t('productGroup.holdingProfile.excluded')}
                  </Grid>
                  <Grid item xs={12}>
                    {!!excluded?.adidmas?.length && (
                      <Typography variant="caption">
                        {t('productGroup.holdingProfile.excluded.adidmas')}:
                      </Typography>
                    )}
                    {excluded?.adidmas &&
                      excluded.adidmas.map(e => (
                        <Typography variant="caption">{e.adidma}</Typography>
                      ))}
                  </Grid>
                  <Grid item xs={12}>
                    {!!excluded?.province?.length && (
                      <Typography variant="caption">
                        {t('productGroup.holdingProfile.excluded.province')}:
                      </Typography>
                    )}
                    {excluded?.province &&
                      excluded.province.map(e => (
                        <Typography variant="caption">
                          {e.stateProvince}
                        </Typography>
                      ))}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className={style.holdingProfilesContainerMenuItem}>
                <div className={style.containerAppBar}>
                  <Typography className={style.containerTitle}>
                    {t('productGroup.productProfiles')}
                  </Typography>
                  {viewMode === VIEW_MODE_STATES.READ && !readOnly && (
                    <div className={style.addMore}>
                      <Button
                        onClick={handleAddProfile}
                        style={{
                          color: 'white',
                          textTransform: 'none',
                        }}
                        disabled={readOnly}
                        endIcon={<AddIcon />}
                      >
                        {t('productGroup.holdingProfile.addMore')}
                      </Button>
                    </div>
                  )}
                </div>
                <VerticalTabsForMenuItems
                  refreshOnSave={refreshOnSave}
                  viewMode={viewMode}
                  readOnly={readOnly}
                  setViewMode={setViewMode}
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
